import React from 'react';
import { CheckIcon } from 'lucide-react';
const features = ['Preventive maintenance workflows', 'Ready-to-use inspection checklists', 'Troubleshooting sequences', 'Work-order tools', 'Asset & maintenance records', 'Professional maintenance control tools'];
const areas = ['Prevent', 'Inspect', 'Troubleshoot', 'Execute', 'Record', 'Control'];
export function SystemSection() {
  return <section className="bg-brand-carbon px-4 py-4 text-white" data-id="element-161" data-mp="31kgxp49hwd49">
      <div className="mx-auto max-w-3xl" data-id="element-162" data-mp="31m0gp2mjd29q">
        <h2 className="mb-0.5 text-center font-display text-[20px] leading-tight text-white sm:text-3xl" data-id="element-163" data-mp="2wth1604afx2a">
          The Complete <span className="text-brand-yellow" data-id="element-164" data-mp="2stgnihp0jpwa">6-in-1</span> Maintenance System
        </h2>
        <p className="mb-2 text-center font-cond text-sm font-bold uppercase tracking-wide text-brand-yellow sm:text-lg" data-id="element-165" data-mp="2nu3qj44fh2fz">
          🔧 MAINTENANCE READY™
        </p>

        <ul className="mb-2.5 flex flex-wrap justify-center gap-1.5" data-id="element-166" data-mp="2dv4pa6lzs930">
          {areas.map(area => <li key={area} className="rounded border border-brand-yellow/60 px-2 py-0.5 font-cond text-[11px] font-semibold uppercase tracking-wide text-brand-yellow" data-id="element-167" data-mp="2dxh5ofc3qbdy">
              {area}
            </li>)}
        </ul>

        <ul className="grid gap-x-5 gap-y-1.5 sm:grid-cols-2" data-id="element-168" data-mp="u1aagpacmvyw">
          {features.map(feature => <li key={feature} className="flex items-start gap-2 text-[13px] font-semibold sm:text-[15px]" data-id="element-169" data-mp="z04shp0hsghy">
              <CheckIcon aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0 text-brand-yellow" strokeWidth={3} data-id="element-170" data-mp="1mpz4k4czm115" />
              {feature}
            </li>)}
        </ul>
      </div>
    </section>;
}